const STATUS_CODE_OK = 200;

const PAGE_ERROR = {
  ERROR: 'error',
  CLOSED: 'closed',
  LOANS_CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS: 'loansClosedToUserWithoutCreditWorthiness',
};

const CODES = {
  ACCIDENT: 'ANL',
  DISPLACEMENT_CHILD_BIRTH: 'CP4',
  DISPLACEMENT_DEATH_SPOUSE: 'CP2',
  DISPLACEMENT_DEATH_CHILD: 'CQ2',
  DISPLACEMENT_DEATH_FAMILY: 'CM2',
};

const SICKNESS = {
  CATALOGATION: '001',
  CODES: [CODES.ACCIDENT, 'ENF','ANL'],
};

const DISPLACEMENT = {
  CODES: [
    CODES.DISPLACEMENT_DEATH_CHILD,
    CODES.DISPLACEMENT_DEATH_SPOUSE,
    CODES.DISPLACEMENT_CHILD_BIRTH,
    CODES.DISPLACEMENT_DEATH_FAMILY,
  ],
};

const MODALS = {
  REQUEST: '#modalRequest',
  VACATION: '#modalCalendarGrid',
  WARNING_REQUEST_VACATION: '#warningRequestVacation',
  COACHMARK: '#modalCoachmark',
  TEAM_REQUESTS: {
    APPROVE_ALL: '#modalTeamRequestsApproveAll',
    APPROVE: '#modalTeamRequestApprove',
    REMOVE: '#modalTeamRequestRemove',
  },
  REMOVE_PERIOD: '#modalRemovePeriod',
  CALENDAR_GRID: '#modalCalendarGrid',
  SIGN_UP: '#modalSignUp',
  LOANS_CONFIRMATION_SIGN_UP: '#loansConfirmationSignUpModal',
  MANDATORY_INSURANCE: '#modalMandatoryInsurance',
  BENEFIT_REQUEST: '#modalBenefitRequest',
  BENEFIT_REQUEST_LIST: '#modalRequestList',
  BENEFIT_DELEGATED_REQUEST_LIST: '#modalDelegatedRequestList',
  LOANS_REPAYMENT: '#modalLoansRepayment',
  MY_LOANS: '#modalMyLoans',
  REQUEST_CADASTRAL: '#modalRequestCadastral',
  QUESTION_CADASTRAL: '#modalQuestionCadastral',
  DELEGATIONS_MANAGER: '#modalDelegationManager',
  WARNING_DELEGATION_MODAL: '#modalWarningDelegation',
  NEED_A_LOAN: '#modalNeedALoan',
  CANNOT_SIGNUP: '#modalCannotSignup',
  WAGE_ADVANCE_MODAL: '#wageAdvanceModal',
  SOLIDARITY_REQUEST_MODAL: '#solidarityRequestModal',
  AUTHENTICATION_ERROR_MODAL: '#authenticationErrorModal',
  SOCIAL_SECURITY_MODAL: '#socialSecurityModal',
  DEV_CHANGE_EMPLOYEE_MOBILE: '#devChangeEmployeeMobile',
  DELEGATED_REQUEST_MODAL: '#modalDelegatedRequest',
};

const ANSWERS = {
  YES: 'yes',
  NO: 'no',
};

const MODES = {
  CREATE: 'create',
  EDIT: 'edit',
};

const EVENTS = {
  CONTEXT_MENU_REMOVE: 'CONTEXTMENU_REMOVE_PERIOD',
  REQUEST_DAY_CLICK: 'REQUEST_DAY_CLICK',
  CALENDAR_INLINE_CHANGE_DATE: 'CALENDAR_INLINE_CHANGE_DATE',
  ADD_PERIOD: 'add-period',
  FILTER_PERIOD: 'filter-period',
  ICON_DELEGATIONS: 'icon-delegations',
  CHANGE_TITLE: 'change-title',
  BADGE_NUMBER: 'badge-number',
  REFRESH_ON_FOOD_BENEFIT_MANAGER: 'refresh-on-food-benefit-manager',
  LOANS_AMOUNT_SIMULATION_REFRESH_ERRORS: 'loans-amount-simulation-refresh-errors',
  WITHOUT_LOANS_ACCESS: 'withoutloansAccess',
  BUTTON_SICK_LEAVE_REPORTS_DISABLED: 'button-sick-leave-reports-disabled',
  REFRESH_EMPLOYEE: 'refresh-employee',
};

const VACATIONS_ABSENCES_ROOT = 'vacations-absences';

const MANAGER_MAINNAVBAR_STATES = {
  ROOT: VACATIONS_ABSENCES_ROOT,
  EMPLOYEE_CALENDAR: VACATIONS_ABSENCES_ROOT + '.employee-calendar',
  MY_VACATIONS: VACATIONS_ABSENCES_ROOT + '.my-vacations',
  TEAM_CALENDAR: VACATIONS_ABSENCES_ROOT + '.team-calendar',
  TEAM_REQUESTS: VACATIONS_ABSENCES_ROOT + '.team-requests',
  DELEGATE: VACATIONS_ABSENCES_ROOT + '.delegations',
};

const HOLIDAY_SUMMARY_VISIBILITY_STATES = [
  MANAGER_MAINNAVBAR_STATES.MY_VACATIONS,
  MANAGER_MAINNAVBAR_STATES.EMPLOYEE_CALENDAR,
];

const EMPLOYEE_AFK_VISIBILITY_STATES = [
  MANAGER_MAINNAVBAR_STATES.TEAM_REQUESTS,
  MANAGER_MAINNAVBAR_STATES.TEAM_CALENDAR,
  MANAGER_MAINNAVBAR_STATES.DELEGATE,
];

const MAX_PERIODS = 4;

const COOKIES = {
  COACHMARK: 'dontshowcoachmark',
};

const CONTEXT_MENU_TAG = 'calendar-context-menu';

const VALIDATION_ERRORS = {
  SICK_LEAVE_REPORTS: {
    INVALID_ORDER: 'sickLeaveReportsInvalidOrder',
    INVALID_DATE: 'sickLeaveReportsInvalidDate',
  },
};

const FOOD_BENEFIT_STATES = {
  initial: '',
  success: 'success',
  error: 'error',
  requested: 'requested',
  approved: 'approved',
  approve: 'approve',
  modified: 'modified',
};

const VACATIONS_ABSENCES_STATES = {
  requested: 'requested',
  approved: 'approved',
};

const VACATION ='vacation';

const CALENDAR_LAST_YEAR_PAGINATION_ALLOWED = 2017;

const ABSENCE = 'absence';

const DELEGATION_STATES = {
  CREATE: 'create',
  CANCEL: 'cancel',
  EDIT: 'edit',
  SUCCESS: 'success',
  ERROR: 'error',
};

const CURRENCIES = {
  EURO: '€',
};

const CURRENCY = CURRENCIES.EURO;

const USEROLES = {
  MANAGER: 'manager',
  USER: 'usuario',
};

const SWITCHOPTIONS = {
  USER: 'user',
  MANAGER: 'manager',
};

const DELEGATIONS_SWITCH_CONFIG = [
  {
    text: 'GLOBALS.AS_USER',
    value: 'user',
  },
  {
    text: 'GLOBALS.AS_MANAGER',
    value: 'manager',
  },
];

const VISITED_PAGES_VALUES = {
  INDEX_INIT_PAGE: 2,
  VALUE_TO_ADD: 1,
  VALUE_TO_SUBTRACT: 2, //When we back on the app, it adds 1 because the route changes and the "app.run" method is executed too.
};

const ENVIRONMENTS = {
  dev : 'desarrollo',
  pre : 'preproducción',
  pro: 'producción'
};

const JANUARY_INDEX = 0;
const NOVEMBER_INDEX = 10;
const DECEMBER_INDEX = 11;

export {
  STATUS_CODE_OK,
  CODES,
  SICKNESS,
  MODALS,
  ANSWERS,
  MODES,
  EVENTS,
  MANAGER_MAINNAVBAR_STATES,
  HOLIDAY_SUMMARY_VISIBILITY_STATES,
  EMPLOYEE_AFK_VISIBILITY_STATES,
  MAX_PERIODS,
  COOKIES,
  CONTEXT_MENU_TAG,
  VALIDATION_ERRORS,
  DISPLACEMENT,
  FOOD_BENEFIT_STATES,
  CURRENCIES,
  CURRENCY,
  DELEGATION_STATES,
  USEROLES,
  SWITCHOPTIONS,
  DELEGATIONS_SWITCH_CONFIG,
  VISITED_PAGES_VALUES,
  PAGE_ERROR,
  ENVIRONMENTS,
  VACATIONS_ABSENCES_STATES,
  VACATION,
  ABSENCE,
  CALENDAR_LAST_YEAR_PAGINATION_ALLOWED,
  JANUARY_INDEX,
  NOVEMBER_INDEX,
  DECEMBER_INDEX
};



// WEBPACK FOOTER //
// ./client/app/common/domain/constants.js